import React, { useState } from "react";
import { useSelector } from "react-redux";
import userStorage from "store/UserStorage";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { smallShadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";
import { selectCartReload } from "../cartSlice";
import DeliveryMethod from "./DeliveryMethod";
import { formatEuro } from "features/utils";
import DualPrice from "components/Price";
import { SHOW_BGN_PRICES } from "config";

interface DeliveryInfoProps {
  register: any;
}

const DeliveryInfo: React.FC<DeliveryInfoProps> = ({ register }) => {
  const totalPrice = userStorage.selectTotalPriceWithDiscount();
  const reload = useSelector(selectCartReload);
  const [showTransferInfo, setShowTransferInfo] = useState(false);

  return (
    <DeliveryInfoContainer>
      <DeliveryMethod
        register={register}
        setShowTransferInfo={setShowTransferInfo}
      />
      <HR />
      <DeliveryPrice>
        <span className="text-body form-title">Доставка</span>
        <span className="text-sm" style={{ textAlign: "end" }}>
          <span style={{ fontWeight: "bold", color: colors.light_blue }}>
            Безплатна доставка
          </span>
          <br />
          за поръчки над {formatEuro(100)} €{" "}
          {SHOW_BGN_PRICES && <small>(100.00 лв.)</small>}
        </span>
      </DeliveryPrice>
      <HR />
      <DiscountCode>
        <span className="text-xs discount-qa">Промо код?</span>
        <input
          name="discount-code text-body"
          style={{ fontSize: "16px" }}
          placeholder="Въведете код"
        />
      </DiscountCode>
      <SubscriptionLabel>
        <input type="checkbox" name="isSubscribed" ref={register()} />
        <span className="design"></span>
        <span className="text text-xs subscription">
          Абонирайте се за промоционални оферти и ексклузивни промо кодове
        </span>
      </SubscriptionLabel>
      <TotalAmount>
        <span className="text-sm">
          Обща сума на поръчката:{" "}
          <span className="text-body form-title">
            <DualPrice bgn={totalPrice} />
          </span>
        </span>
      </TotalAmount>
      {showTransferInfo && (
        <BankTransfeInfo className="text-xs">
          <p>
            Инструкции за банковия превод
            <br />
            <br />
            Моля, преведете цялата сума по следната банкова сметка
            <br />
            <br />
            Получател: "И клима" ЕООД
            <br />
            Банка: ОББ АД
            <br />
            IBAN: BG03UBBS88881000923749
            <br />
            BIC: UBBSBGSF
            <br />
            За основание напишете номера на поръчката.
            <br />
            <br />
            След като потвърдите поръчката ще получите емайл, който може да
            принтирате и използвате като проформа фактура.
            <br />
            Банковите такси (включително на изпращача и получателя) трябва да се
            заплатят от клиента.
            <br />
            <br />
            Поръчката ви ще ви бъде изпратена само при получено плащане.
            <br />
          </p>
        </BankTransfeInfo>
      )}
    </DeliveryInfoContainer>
  );
};

const DeliveryInfoContainer = styled.div`
  ${smallShadow}
  flex: 1 100%;
  padding: 20px;

  display: flex;
  flex-flow: column;
  align-items: flex-start;

  .form-text {
    color: ${colors.dark_gray};
  }

  @media only screen and (${device.desktop}) {
    flex: 4;
  }
`;

const HR = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.gray};
  margin: 12px 0;
`;

const DeliveryPrice = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const DiscountCode = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;

  .discount-qa {
    color: ${colors.dark_gray};
    margin-bottom: 5px;
  }

  input {
    padding: 10px;
    border: 1px solid ${colors.gray};
    border-radius: 5px;
    color: black;
    margin-bottom: 20px;
  }
`;

const TotalAmount = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  .total-price {
    font-weight: 700;
  }
`;

const SubscriptionLabel = styled.label`
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  .subscription {
    margin-left: 5px;
  }
`;

const BankTransfeInfo = styled.div`
  margin-top: 10px;
  box-sizing: border-box;
  padding: 10px;

  border-radius: 5px;
  border-width: 0;
  -webkit-box-shadow: inset 0px 0px 36px -20px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: inset 0px 0px 36px -20px rgba(0, 0, 0, 0.5);
  box-shadow: inset 0px 0px 36px -20px rgba(0, 0, 0, 0.5);
`;

export default DeliveryInfo;
